<template>
  <div class="tw-bg-light-gray">
    <div class="tw-w-full sm:tw-mb-20">
      <!-- Header -->
      <div class="tw-w-full tw-bg-white tw-shadow-[0_2px_4px_rgba(0,0,0,0.1)]">
        <div
          class="tw-relative tw-m-auto tw-mb-12 tw-flex tw-max-w-6xl tw-flex-col"
        >
          <div class="tw-mb-16 sm:tw-mb-28">
            <div class="tw-flex tw-items-center tw-pt-5">
              <Logo type="timeful" />

              <v-spacer />

              <LandingPageHeader>
                <!-- <v-btn text @click="openHowItWorksDialog">How it works</v-btn>
                <v-btn text href="/blog">Blog</v-btn> -->
                <div v-if="authUser" class="tw-ml-2">
                  <AuthUserMenu />
                </div>
                <v-btn v-else text @click="signIn">Sign in</v-btn>
              </LandingPageHeader>
            </div>

            <!-- <FormerlyKnownAs /> -->
          </div>
          <div
            class="tw-m-auto tw-mb-6 tw-flex tw-flex-col tw-items-center sm:tw-max-w-none"
          >
            <!-- <div
                class="tw-mb-4 tw-flex tw-select-none tw-items-center tw-rounded-full tw-border tw-border-light-gray-stroke tw-bg-white/70 tw-px-2.5 tw-py-1.5 tw-text-sm tw-text-dark-gray"
              >
                We're open source!
                <github-button
                  v-once
                  class="-tw-mb-1 tw-ml-2"
                  href="https://github.com/schej-it/timeful.app"
                  data-show-count="true"
                  aria-label="Star timeful.app on GitHub"
                  >Star</github-button
                >
              </div> -->
            <div
              id="header"
              class="tw-m-auto tw-mb-4 tw-px-4 tw-text-center tw-text-2xl tw-font-medium sm:tw-text-4xl lg:tw-text-4xl xl:tw-text-5xl"
            >
              <h1 class="tw-leading-[3.5rem]">
                Quickly find the best time that works for everybody
              </h1>
              <h3
                class="tw-pt-4 tw-text-lg sm:tw-text-xl lg:tw-text-xl xl:tw-text-2xl"
              >
                For group meetings, 1:1's, or any kind of get together.
              </h3>
            </div>

            <div
              class="lg:tw-text-md tw-text-center tw-text-sm tw-text-very-dark-gray sm:tw-text-lg md:tw-text-lg xl:tw-text-lg"
            >
              Stop asking everyone "share some times you are available"
            </div>
            <ol
              class="lg:tw-text-md tw-ml-4 tw-mt-4 tw-list-decimal tw-text-left tw-text-xs tw-text-very-dark-gray sm:tw-text-sm md:tw-text-base xl:tw-text-base"
            >
              <li class="tw-mb-2">Create and share free meeting link.</li>
              <li class="tw-mb-2">
                Everyone syncs their calendar (or adds time manually)
              </li>
              <li class="tw-mb-2">
                You see the times that works for everyone.
              </li>
              <li class="tw-mb-2">
                Details remain private and inaccessible to other.
              </li>
              <li>Once scheduled, the calendars automatically disconnect.</li>
            </ol>
            <div class="tw-mb-12 tw-mt-6 tw-space-y-2">
              <v-btn
                class="tw-block tw-h-auto tw-min-h-[48px] tw-self-center tw-rounded-full tw-bg-green tw-px-5 tw-text-base sm:tw-px-5 lg:tw-px-5"
                dark
                @click="authUser ? openDashboard() : (newDialog = true)"
                large
                :x-large="$vuetify.breakpoint.mdAndUp"
              >
                <span v-if="authUser">Open dashboard</span>
                <span v-else class="tw-text-center">
                  <span>Schedule a meeting</span>
                  <span class="tw-block">It's free for everyone!</span>
                </span>
              </v-btn>
            </div>
          </div>
        </div>
      </div>
      <div class="tw-flex tw-flex-col tw-items-center">
        <div class="tw-relative tw-w-full">
          <!-- Green background -->
          <!-- <div
            class="tw-absolute -tw-bottom-12 tw-left-1/2 tw-h-[85%] tw-w-screen -tw-translate-x-1/2 tw-bg-green sm:-tw-bottom-20"
          ></div> -->

          <!-- Hero video -->
          <div
            class="tw-relative tw-z-20 tw-w-full tw-rounded-lg tw-border tw-border-light-gray-stroke tw-bg-white tw-shadow-xl sm:tw-rounded-xl md:tw-mx-auto md:tw-w-fit"
          >
            <div
              class="tw-relative tw-mx-4 tw-aspect-square md:tw-size-[700px] lg:tw-size-[800px]"
            >
              <!-- Hero image removed - video now plays directly -->
              <!-- <v-img
                class="tw-absolute tw-left-0 tw-top-0 tw-z-20 tw-size-full tw-transition-opacity tw-duration-300"
                :class="{ 'tw-opacity-0': isVideoPlaying }"
                src="@/assets/img/hero.jpg"
                transition="fade-transition"
                contain
              /> -->
              <video
                class="tw-h-full tw-w-full tw-object-contain"
                muted
                playsinline
                autoplay
                loop
              >
                <source
                  src="@/assets/octocal-homescreen.mp4"
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- How it works -->
    <div
      id="how-it-works"
      class="tw-grid tw-place-content-center tw-bg-white tw-px-4 tw-pb-12 tw-pt-12 tw-shadow-[0_-2px_4px_rgba(0,0,0,0.1)]"
    >
      <div class="tw-mx-auto tw-flex tw-flex-col tw-gap-4">
        <div
          class="tw-mb-4 tw-text-center tw-text-2xl tw-font-medium sm:tw-text-3xl lg:tw-text-4xl"
        >
          Save yourself from asking:<br />
          "Everyone email me times<br />
          you are available to meet."
        </div>
        <section
          class="tw-mx-auto tw-max-w-3xl tw-space-y-8 tw-py-8 tw-text-center"
        >
          <!-- Built for External Attendees -->
          <div>
            <h3 class="tw-text-gray-900 tw-text-lg tw-font-semibold">
              Built for Internal & External Attendees:
            </h3>
            <p class="tw-text-gray-600 tw-mt-2">
              Whether they are on Google or Outlook, or want to add availability
              manually, we bring it all in to find the mutual availability.
            </p>
          </div>

          <!-- Private -->
          <div>
            <h3 class="tw-text-gray-900 tw-text-lg tw-font-semibold">
              Private:
            </h3>
            <p class="tw-text-gray-600 tw-mt-2">
              Details of each calendar are not visible to others. Only the
              overlapping common availability of all attendees is revealed.
            </p>
          </div>

          <!-- Temporary -->
          <div>
            <h3 class="tw-text-gray-900 tw-text-lg tw-font-semibold">
              Temporary:
            </h3>
            <p class="tw-text-gray-600 tw-mt-2">
              Once availability for all attendees is found, your calendar is
              <span class="tw-italic"
                >automatically disconnected from our system.</span
              >
            </p>
          </div>
          <div class="tw-mb-12 tw-mt-6 tw-items-center tw-space-y-2">
            <v-btn
              class="tw-m-auto tw-block tw-h-auto tw-min-h-[48px] tw-self-center tw-rounded-full tw-bg-green tw-px-8 tw-text-base sm:tw-px-8 lg:tw-px-8"
              dark
              @click="signIn"
              large
              :x-large="$vuetify.breakpoint.mdAndUp"
            >
              Schedule a meeting <br />It's free for everyone!
            </v-btn>
            <!-- <div
              v-if="!authUser"
              class="tw-text-center tw-text-xs tw-text-dark-gray sm:tw-text-sm"
            >
              Unlock Additional Features
            </div> -->
          </div>
        </section>

        <!-- <div
          v-for="(step, i) in howItWorksSteps"
          :key="i"
          class="tw-flex tw-items-center tw-gap-2"
        >
          <NumberBullet>{{ i + 1 }}</NumberBullet>
          <div class="tw-text-base tw-font-medium md:tw-text-xl">
            <div v-html="step"></div>
          </div>
        </div> -->
      </div>
      <!-- <div
        class="tw-mb-6 tw-mt-10 tw-text-center tw-text-3xl tw-font-medium md:tw-mb-12 md:tw-mt-20 md:tw-text-6xl"
      >
        It's that simple.
      </div>
      <v-img
        alt="schej character"
        src="@/assets/schej_character.png"
        :height="isPhone ? 200 : 300"
        transition="fade-transition"
        contain
        class="-tw-mb-12"
      /> -->
    </div>

    <!-- Video -->
    <!-- <div
      class="tw-flex tw-justify-center tw-bg-green tw-px-4 tw-pb-12 tw-pt-24 md:tw-pb-16"
    >
      <div
        class="tw-h-[300px] tw-max-w-3xl tw-flex-1 sm:tw-h-[400px] md:tw-h-[450px]"
      >
        <iframe
          class="tw-h-full tw-w-full"
          src="https://www.youtube.com/embed/vFkBC8BrkOk?si=pF64JAIyDhom_1do"
          title="OctoCal demo"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>
    </div> -->

    <!-- Reddit Testimonials -->
    <!-- <div class="tw-flex tw-justify-center tw-bg-light-gray tw-py-12">
      <div class="tw-mx-4 tw-max-w-3xl tw-flex-1 sm:tw-mx-16">
        <div class="tw-text-center">
          <Header> People love us on Reddit! </Header>
          <div
            class="tw-mt-8 tw-grid tw-grid-cols-1 tw-gap-4 sm:tw-grid-cols-2"
          >
            <div
              v-for="(comment, index) in redditComments"
              :key="index"
              class="tw-flex tw-flex-col tw-rounded-lg tw-bg-white tw-p-4 tw-shadow-md"
              :class="{
                'sm:tw-col-span-2 sm:tw-mx-auto sm:tw-max-w-md':
                  redditComments.length % 2 !== 0 &&
                  index === redditComments.length - 1,
              }"
            >
              <div class="tw-flex tw-flex-1 tw-items-center">
                <div
                  class="reddit-comment tw-text-left tw-text-sm tw-text-very-dark-gray"
                  v-html="comment.text.replace(/\n/g, '<br />')"
                ></div>
              </div>
              <div
                class="tw-my-4 tw-h-px tw-w-full tw-bg-light-gray-stroke"
              ></div>
              <div class="tw-flex tw-items-center tw-justify-between">
                <div class="tw-text-right">
                  <a
                    :href="comment.link"
                    target="_blank"
                    class="tw-text-sm tw-font-medium tw-text-dark-gray hover:tw-underline"
                  >
                    {{ comment.author }}
                  </a>
                </div>
                <div class="tw-flex tw-items-center tw-gap-2">
                  <v-avatar size="24">
                    <v-img :src="comment.picture" />
                  </v-avatar>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- FAQ -->
    <!-- <div class="tw-flex tw-justify-center tw-pt-12">
      <div class="tw-mx-4 tw-mb-12 tw-max-w-3xl tw-flex-1 sm:tw-mx-16">
        <div id="faq-section" class="tw-text-center lg:tw-pt-3">
          <Header> Frequently Asked Questions </Header>
          <div
            class="tw-grid tw-grid-cols-1 tw-gap-3 sm:tw-text-xl lg:tw-text-2xl"
          >
            <FAQ
              v-for="faq in faqs"
              :key="faq.question"
              @signIn="signIn"
              v-bind="faq"
            />
          </div>
        </div>
      </div>
    </div> -->

    <!-- Sign in dialog -->
    <SignInDialog v-model="signInDialog" @signIn="_signIn" />

    <!-- New event dialog -->
    <NewDialog v-model="newDialog" no-tabs @signIn="signIn" />

    <!-- Add the dialog component -->
    <HowItWorksDialog
      v-if="showHowItWorksDialog"
      v-model="showHowItWorksDialog"
    />
  </div>
</template>

<style scoped>
@media screen and (min-width: 375px) and (max-width: 640px) {
  #header {
    font-size: 1.875rem !important; /* 30px */
    line-height: 2.25rem !important; /* 36px */
  }
}
</style>
<style>
.rdt-h {
  @apply tw-rounded tw-bg-light-green/20 tw-px-px tw-text-black;
}
</style>

<script>
import LandingPageCalendar from "@/components/landing/LandingPageCalendar.vue"
import { isPhone, signInGoogle, signInOutlook } from "@/utils"
import FAQ from "@/components/FAQ.vue"
import Header from "@/components/Header.vue"
import NumberBullet from "@/components/NumberBullet.vue"
import NewEvent from "@/components/NewEvent.vue"
import NewDialog from "@/components/NewDialog.vue"
import LandingPageHeader from "@/components/landing/LandingPageHeader.vue"
import Logo from "@/components/Logo.vue"
import GithubButton from "vue-github-button"
import SignInDialog from "@/components/SignInDialog.vue"
import { calendarTypes } from "@/constants"
import HowItWorksDialog from "@/components/HowItWorksDialog.vue"
// import PronunciationMenu from "@/components/PronunciationMenu.vue"
import { mapState } from "vuex"
import AuthUserMenu from "@/components/AuthUserMenu.vue"
import FormerlyKnownAs from "@/components/FormerlyKnownAs.vue"

export default {
  name: "Landing",

  metaInfo: {
    title: "Octocal Group Meeting Scheduler",
    meta: [
      {
        name: "description",
        content:
          "Octocal helps you find the best time for a group to meet. It is a free availability poll that is easy to use and integrates with your calendar.",
      },
      {
        property: "og:title",
        content: "Octocal - Find a time to meet",
      },
      {
        property: "og:description",
        content:
          "Octocal helps you find the best time for a group to meet. It is a free availability poll that is easy to use and integrates with your calendar.",
      },
      {
        property: "og:url",
        content: "https://octocal.app",
      },
      {
        property: "og:image",
        content: "https://octocal.app/img/ogImage.png",
      },
      {
        property: "og:type",
        content: "website",
      },
      {
        name: "twitter:card",
        content: "summary_large_image",
      },
      {
        name: "twitter:title",
        content: "Octocal - Find a time to meet",
      },
      {
        name: "twitter:description",
        content:
          "Octocal helps you find the best time for a group to meet. It is a free availability poll that is easy to use and integrates with your calendar.",
      },
      {
        name: "twitter:image",
        content: "https://octocal.app/img/ogImage.png",
      },
    ],
  },

  components: {
    LandingPageCalendar,
    FAQ,
    Header,
    NumberBullet,
    NewEvent,
    NewDialog,
    LandingPageHeader,
    GithubButton,
    Logo,
    SignInDialog,
    HowItWorksDialog,
    // PronunciationMenu,
    AuthUserMenu,
    FormerlyKnownAs,
  },

  data: () => ({
    signInDialog: false,
    newDialog: false,
    githubSnackbar: true,
    howItWorksSteps: [
      "Create a meeting event",
      "Share the meeting link with your group for them to fill out",
      "See where everybody's availability overlaps.",
    ],
    faqs: [
      {
        question: "Does OctoCal support timezones?",
        answer:
          "Yes! OctoCal automatically converts all times to the viewer's local timezone. There's also a timezone selector at the bottom of every meeting poll if you would like to manually change it.",
      },
      {
        question: "How many people can respond to an event?",
        answer:
          "Unlimited! We've tested events with over 500+ responses and it works great.",
      },
      {
        question: "What calendars does OctoCal integrate with?",
        answer:
          "OctoCal allows you to autofill your availability from your Google Calendar, Outlook, and Apple Calendar. We are working on adding more calendar types soon!",
      },
      {
        question: "Is calendar access required in order to use OctoCal?",
        answer:
          "Nope! You can manually input your availability, but we highly recommend allowing calendar access in order to view your calendar events while doing so.",
      },
      {
        question: "Will other people be able to see my calendar events?",
        answer:
          "Nope! All other users will be able to see is the availability that you enter for an event.",
      },
      {
        question: "How do I edit my availability?",
        answer:
          'If you are signed in, simply click the "Edit availability" button. If you entered your availability as a guest, hover over your name and click the pencil icon next to it.',
      },
      {
        question: "How is OctoCal different from Lettucemeet or When2meet?",
        points: [
          "Much better UI (web and mobile)",
          "Seamless and working calendar integration",
          "A slew of other features that we don't have space to list here",
        ],
      },
      {
        question: `I want it so that only I can see people's responses.`,
        answer: `Just check "Only show responses to event creator" under Advanced Options when creating your event! Other respondees will not be able to see each other's names or availability.`,
        authRequired: true,
      },
      {
        question: `Can I receive emails when someone fills out my event?`,
        answer: `Absolutely! Check "Email me each time someone joins my event" when creating an event. <br><br>To receive email notifications after a specific number (X) of responses are added, check "Email me after X responses" in Advanced Options.`,
        authRequired: true,
      },
      {
        question: `How do I send reminders to people to fill out an event?`,
        answer: `Open the "Email Reminders" section when creating an event and input everybody's email address. Reminder emails will be sent the day of event creation, one day after, and three days after. <br><br>You will also receive an email once everybody has filled out the OctoCal.`,
        authRequired: true,
      },
    ],
    redditComments: [
      {
        text: "Genuinely the <span class='rdt-h'>best lightweight version of this kind of website</span> that I've come across so far, exceptional.",
        author: "u/voipClock",
        link: "https://www.reddit.com/r/opensource/comments/1klu471/comment/mt4l2ab",
        picture:
          "https://www.redditstatic.com/avatars/defaults/v2/avatar_default_1.png",
      },
      {
        text: "It's almost <span class='rdt-h'>comically easy</span> to schedule meetings with OctoCal.",
        author: "u/stuffingmybrain",
        link: "https://www.reddit.com/r/schej/comments/1drs26z/comment/lb8rvty",
        picture:
          "https://styles.redditmedia.com/t5_qqojf/styles/profileIcon_snooa54a8eae-bc7f-406f-9778-b3b9dfb818e5-headshot.png?width=64&height=64&frame=1&auto=webp&crop=&s=a0a91575ff7cfc3b6698cac69da6c012c7deb8d6",
      },
      {
        text: "OctoCal is everything I've ever wanted and more. On top of that, <span class='rdt-h'>community support is the best I've seen</span> of any app or software, ever.",
        author: "u/DMODD",
        link: "https://www.reddit.com/r/schej/comments/1drs26z/comment/lb8udud",
        picture:
          "https://www.redditstatic.com/avatars/defaults/v2/avatar_default_6.png",
      },
      {
        text: "With OctoCal, <span class='rdt-h'>I'm very quickly able to figure out the optimal time</span> to schedule online extra help sessions before an exam.",
        author: "u/crackwurst",
        link: "https://www.reddit.com/r/schej/comments/1drs26z/comment/lb9dmbe",
        picture:
          "https://www.redditstatic.com/avatars/defaults/v2/avatar_default_3.png",
      },
      {
        text: "Exactly what I was looking for! Clear and clean interface, also on mobile (<span class='rdt-h'>Doodle is a disaster</span>).",
        author: "u/Willem1976",
        link: "https://www.reddit.com/r/opensource/comments/1dlol7r/comment/lkn7sle",
        picture:
          "https://styles.redditmedia.com/t5_c0qtc/styles/profileIcon_snooa9d429ce-e3d9-458a-be9e-1b6dd157a209-headshot.png?width=64&height=64&frame=1&auto=webp&crop=&s=7eba44ea268928b969bcf73ee8667357412132ca",
      },
      // {
      //   text: "Thank you very much! My workplace cannot seem to pick between when2meet and Doodle and I feel like this brings the best of each into one.\n\nWell done <3",
      //   author: "u/jadiepants",
      //   link: "https://www.reddit.com/r/opensource/comments/1dlol7r/comment/m6bf3li",
      //   picture:
      //     "https://styles.redditmedia.com/t5_d7myp/styles/profileIcon_snoof50f1128-f439-433b-a6b2-8e987630e506-headshot.png?width=64&height=64&frame=1&auto=webp&crop=&s=94077bf80603c2855747f1bfc0b9dd1539fae75c",
      // },
    ],
    rive: null,
    showSchejy: false,
    showHowItWorksDialog: false,
    // isVideoPlaying: false, // Removed - no longer needed without hero image
  }),

  computed: {
    ...mapState(["authUser"]),
    isPhone() {
      return isPhone(this.$vuetify)
    },
  },

  methods: {
    loadRiveAnimation() {
      // if (!this.rive) {
      //   this.rive = new Rive({
      //     src: "/rive/schej.riv",
      //     canvas: document.querySelector("canvas"),
      //     autoplay: false,
      //     stateMachines: "wave",
      //     onLoad: () => {
      //       // r.resizeDrawingSurfaceToCanvas()
      //     },
      //   })
      //   setTimeout(() => {
      //     this.showSchejy = true
      //     setTimeout(() => {
      //       this.rive.play("wave")
      //     }, 1000)
      //   }, 4000)
      // } else {
      //   this.rive.play("wave")
      // }
    },
    _signIn(calendarType) {
      if (calendarType === calendarTypes.GOOGLE) {
        signInGoogle({ state: null, selectAccount: true })
      } else if (calendarType === calendarTypes.OUTLOOK) {
        // NOTE: selectAccount is not supported implemented yet for Outlook, maybe add it later
        signInOutlook({ state: null, selectAccount: true })
      }
    },
    signIn() {
      this.signInDialog = true
    },
    openHowItWorksDialog() {
      this.showHowItWorksDialog = true
      this.$posthog.capture("how_it_works_clicked")
    },
    // onPlay() {
    //   // Removed - no longer needed without hero image fade transition
    //   setTimeout(() => {
    //     this.isVideoPlaying = true
    //   }, 1000)
    // },
    openDashboard() {
      this.$router.push({ name: "home" })
    },
  },

  beforeDestroy() {
    this.rive?.cleanup()
  },

  watch: {
    [`$vuetify.breakpoint.name`]: {
      immediate: true,
      handler() {
        if (this.$vuetify.breakpoint.mdAndUp) {
          setTimeout(() => {
            this.loadRiveAnimation()
          }, 0)
        }
      },
    },
  },
}
</script>
